import { Heading } from '@msaf/core-react'
import { FeatureAction } from '../../../../components/pdf/types'
import { getCollectionAggregateForProperty } from '../utils'
import { toDollarCurrencyFormat } from '../../../utils'
import { PdfReadOnlyField } from '../../../../components/pdf/read-only-field'

interface AlternateForesteryPlantingSummaryType {
  features: FeatureAction[]
}

export const AlternateForesteryPlantingSummary = ({ features }: AlternateForesteryPlantingSummaryType) => {
  const totalPlants = getCollectionAggregateForProperty(features, 'numberOfPlants')
  const totalCost = getCollectionAggregateForProperty(features, 'proposedCost')
  const kmrContribution = getCollectionAggregateForProperty(features, 'kmrContribution')

  return (
    <section className='l-section--no-break-inside l-pdf-container--margin-small'>
      <Heading level={3} className='c-field__heading--margin-small'>
        Alternative forestry planting costings
      </Heading>
      <PdfReadOnlyField
        fieldName='Total plants (based on per ha spacing in your forestry plan)'
        value={`${totalPlants} plants`}
      />
      <PdfReadOnlyField
        fieldName='Total KMR contribution (based on per ha KMR contribution)'
        value={toDollarCurrencyFormat(kmrContribution)}
      />
      <PdfReadOnlyField
        fieldName='Total landowner contribution (total estimated price in your forestry plan, minus the KMR contribution)'
        value={toDollarCurrencyFormat(totalCost - kmrContribution)}
      />
    </section>
  )
}
